module.exports = __webpack_public_path__ + "media/homepage_landingvideo.37d4f0e4.mp4";